"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _base = _interopRequireDefault(require("../../../style/themes/base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledNavbar = _styledComponents.default.div`
  &.DayPicker-NavBar {
    display: flex;
    justify-content: space-between;
    padding: 0;
    top: 0;
    height: 40px;
  }
`;
StyledNavbar.defaultProps = {
  theme: _base.default
};
var _default = StyledNavbar;
exports.default = _default;